// One tile in the Symbol Vault.
//
// Falls back to the old gradient placeholder if `symbolArt` finds nothing at all, which only
// happens if the asset directory is missing — better a plain orb than a broken image icon.

import { symbolArt } from './art';

export function SymbolOrb({ name }: { name: string }) {
  const art = symbolArt(name);

  if (!art) return <div className="omedia atmos ph" />;

  return (
    <img
      className="osym-art"
      src={art.url}
      // An aura is decorative — it carries no meaning about the symbol, and the name is already
      // rendered as text directly below, so announcing either would just be noise.
      alt=""
      aria-hidden="true"
      loading="lazy"
      decoding="async"
      draggable={false}
    />
  );
}
